// ACTIONS
export const APP_ERROR = 'APP_ERROR';
export const APP_LOADING = 'APP_LOADING';
export const APP_LOGOUT = 'APP_LOGOUT';
export const GET_GRADEBOOK_SETTINGS_SUCCESS = 'GET_GRADEBOOK_SETTINGS_SUCCESS';
export const GRADEBOOK_SETTINGS_UPDATING = 'GRADEBOOK_SETTINGS_UPDATING';
export const RESET_GRADEBOOK = 'RESET_GRADEBOOK';
export const REMOVE_ASSIGNMENT = 'REMOVE_ASSIGNMENT';
export const SET_GRADEBOOK_SEARCH_PHRASE = 'SET_GRADEBOOK_SEARCH_PHRASE';
export const SET_GRADEBOOK_EXCEPTION_GROUPS = 'SET_GRADEBOOK_EXCEPTION_GROUPS';
export const SET_GRADEBOOK_FILTER_TYPES = 'SET_GRADEBOOK_FILTER_TYPES';
export const SET_GRADEBOOK_V2_ACTIVE = 'SET_GRADEBOOK_V2_ACTIVE';
export const SET_SHOW_PERCENT = 'SET_SHOW_PERCENT';
export const SET_VISIBLE_FILTER_SECTION = 'SET_VISIBLE_FILTER_SECTION';
export const TOGGLE_SHOW_FILTER_OPTIONS_GRADEBOOK =
  'TOGGLE_SHOW_FILTER_OPTIONS_GRADEBOOK';
export const UPDATE_SEARCH_TYPE = 'UPDATE_SEARCH_TYPE';
export const UPDATE_SEARCH_TYPE_MENU = 'OPEN_SEARCH_TYPE_MENU';
export const UPDATE_GRADEBOOK = 'UPDATE_GRADEBOOK';
export const UPDATE_GRADEBOOK_ALERT = 'UPDATE_GRADEBOOK_ALERT';
export const UPDATE_GRADEBOOK_INSTRUCTOR = 'UPDATE_GRADEBOOK_INSTRUCTOR';
export const UPDATE_GRADEBOOK_STUDENT = 'UPDATE_GRADEBOOK_STUDENT';
export const UPDATE_REEF_STATUS = 'UPDATE_REEF_STATUS';
export const UPDATE_REEF_COURSE = 'UPDATE_REEF_COURSE';
export const UPDATE_REEF_STATUS_REQUEST = 'UPDATE_REEF_STATUS_REQUEST';
export const UPDATE_REEF_STATUS_SUCCESS = 'UPDATE_REEF_STATUS_SUCCESS';
export const UPDATE_REEF_STATUS_ERROR = 'UPDATE_REEF_STATUS_ERROR';
export const TOGGLE_CATEGORY_EXPAND_COLLAPSE =
  'TOGGLE_CATEGORY_ID_EXPAND_COLLAPSE';
export const TOGGLE_PERFORMANCE_OVERVIEW_COLLAPSE =
  'TOGGLE_PERFORMANCE_OVERVIEW_COLLAPSE';
export const PATCH_USER_LMS = 'PATCH_USER_LMS';
export const GET_ASSIGNMENT_COMPLETION_STATUSES_REQUEST =
  'GET_ASSIGNMENT_COMPLETION_STATUSES_REQUEST';
export const GET_ASSIGNMENT_COMPLETION_STATUSES_SUCCESS =
  'GET_ASSIGNMENT_COMPLETION_STATUSES_SUCCESS';
export const GET_ASSIGNMENT_COMPLETION_STATUSES_ERROR =
  'GET_ASSIGNMENT_COMPLETION_STATUSES_ERROR';
export const SET_HIGHLIGHT_TO_ITEMS = 'SET_HIGHLIGHT_TO_ITEMS';
export const SET_SCROLL_TO_ITEM = 'SET_SCROLL_TO_ITEM';

// Unverified - REMOVE IF NOT USED AFTER DONE WITH EPIC
export const GET_USER = 'GET_USER';
export const PATCH_USER_SAPLING = 'PATCH_USER_SAPLING';
export const ERROR_USER = 'ERROR_USER';
export const ADD_FOLDER = 'ADD_FOLDER';
export const UPDATE_FOLDER = 'UPDATE_FOLDER';
export const DELETE_COURSE_GRADEBOOK_CATEGORIES =
  'DELETE_COURSE_GRADEBOOK_CATEGORIES';
export const UPDATE_COURSE_GRADEBOOK_CATEGORIES =
  'UPDATE_COURSE_GRADEBOOK_CATEGORIES';
export const ADD_ACTIVITY = 'ADD_ACTIVITY';
export const UPDATE_ACTIVITY = 'UPDATE_ACTIVITY';
export const RENAMED_ACTIVITY = 'RENAMED_ACTIVITY';
export const ADD_SUB_ACTIVITY = 'ADD_SUB_ACTIVITY';
export const UPDATE_SUB_ACTIVITY = 'UPDATE_SUB_ACTIVITY';
export const UNASSIGN_ACTIVITY = 'UNASSIGN_ACTIVITY';
export const RESTORE_ACTIVITY = 'RESTORE_ACTIVITY';
export const BULK_UPSERT = 'BULK_UPSERT';
export const REFRESH_CONTENT = 'REFRESH_CONTENT';
export const BATCH_ASSIGN = 'BATCH_ASSIGN';
export const GET_GRADEBOOK_SUCCESS = 'GET_GRADEBOOK_SUCCESS';
export const GET_GRADEBOOK_NEXT_PAGE_SUCCESS =
  'GET_GRADEBOOK_NEXT_PAGE_SUCCESS';
export const GET_GRADEBOOK_AVERAGES_SUCCESS = 'GET_GRADEBOOK_AVERAGES_SUCCESS';
export const GET_GRADEBOOK_REQUEST = 'GET_GRADEBOOK_REQUEST';
export const GET_GRADEBOOK_ERROR = 'GET_GRADEBOOK_ERROR';
export const GET_INSTRUCTOR_GRADEBOOK_SUCCESS =
  'GET_INSTRUCTOR_GRADEBOOK_SUCCESS';
export const GET_INSTRUCTOR_GRADEBOOK_REQUEST =
  'GET_INSTRUCTOR_GRADEBOOK_REQUEST';
export const GET_INSTRUCTOR_GRADEBOOK_ERROR = 'GET_INSTRUCTOR_GRADEBOOK_ERROR';
export const REMOVE_ITEMS = 'REMOVE_ITEMS';
export const REORDER_ITEMS = 'REORDER_ITEMS';
export const TOGGLE_FOLDER = 'TOGGLE_FOLDER';
export const TOGGLE_INDIVIDUAL_STUDENT_GRADEBOOK =
  'TOGGLE_INDIVIDUAL_STUDENT_GRADEBOOK';
export const UPDATE_INDIVIDUAL_STUDENT_GRADEBOOK =
  'UPDATE_INDIVIDUAL_STUDENT_GRADEBOOK';
export const OPEN_INDIVIDUAL_STUDENT_GRADEBOOK =
  'OPEN_INDIVIDUAL_STUDENT_GRADEBOOK';
export const CLOSE_INDIVIDUAL_STUDENT_GRADEBOOK =
  'CLOSE_INDIVIDUAL_STUDENT_GRADEBOOK';
export const SET_INDIVIDUAL_STUDENT_GRADEBOOK =
  'SET_INDIVIDUAL_STUDENT_GRADEBOOK';
export const SELECT_INDIVIDUAL_STUDENT_GRADEBOOK =
  'SELECT_INDIVIDUAL_STUDENT_GRADEBOOK';
export const INDIVIDUAL_STUDENT_GRADEBOOK_LOADING =
  'INDIVIDUAL_STUDENT_GRADEBOOK_LOADING';
export const GET_INDIVIDUAL_STUDENT_GRADEBOOK_DATA =
  'GET_INDIVIDUAL_STUDENT_GRADEBOOK_DATA';
export const SET_ACTIVE_MYCOURSE_SECTION = 'SET_ACTIVE_MYCOURSE_SECTION';
export const CLEAR_ACTIVE_MYCOURSE_SECTION = 'CLEAR_ACTIVE_MYCOURSE_SECTION';
export const SET_CURRENT_MYCOURSE_BREADCRUMBS =
  'SET_CURRENT_MYCOURSE_BREADCRUMBS';
export const CLEAR_TOGGLED_FOLDERS = 'CLEAR_TOGGLED_FOLDERS';
export const TOGGLE_CHECK_ITEMS = 'TOGGLE_CHECK_ITEMS';
export const CLEAR_TOGGLED_CHECK_ITEMS = 'CLEAR_TOGGLED_CHECK_ITEMS';
export const TOGGLE_WRITING_ASSIGNMENT = 'TOGGLE_WRITING_ASSIGNMENT';
export const CLEAR_TOGGLED_WRITING_ASSIGNMENTS =
  'CLEAR_TOGGLED_WRITING_ASSIGNMENTS';
export const CLEAR_HIGHLIGHT_TO_ITEMS = 'CLEAR_HIGHLIGHT_TO_ITEMS';
export const CLEAR_SCROLL_TO_ITEM = 'CLEAR_SCROLL_TO_ITEM';
export const ALERT_LOAD = 'ALERT_LOAD';
export const ALERT_DISMISS = 'ALERT_DISMISS';
export const APP_HASH = 'APP_HASH';
export const DOWNTIME_MESSAGE = 'DOWNTIME_MESSAGE';
export const GET_CUSTOM_CONTENT = 'GET_CUSTOM_CONTENT';
export const UPDATE_CUSTOM_CONTENT = 'UPDATE_CUSTOM_CONTENT';
export const CUSTOM_CONTENT_ADDING_TO_LIBRARY =
  'CUSTOM_CONTENT_ADDING_TO_LIBRARY';
export const RENAMED_CUSTOM_CONTENT = 'RENAMED_CUSTOM_CONTENT';
export const GET_COURSE_ROSTER = 'GET_COURSE_ROSTER';
export const UPDATE_DROP_DATE_STUDENTS = 'UPDATE_DROP_DATE_STUDENTS';
export const GET_COURSE_GROUP_SETS = 'GET_COURSE_GROUP_SETS';
export const GET_COURSE_EXCEPTION_GROUPS = 'GET_COURSE_EXCEPTION_GROUPS';
export const UPDATE_GROUP_SET_SHALLOW = 'UPDATE_GROUP_SET_SHALLOW';
export const ADD_GROUP_SET = 'ADD_GROUP_SET';
export const PUT_EXCEPTIONS = 'PUT_EXCEPTIONS';
export const SET_BACK_PAGE = 'SET_BACK_PAGE';
export const REMOVE_LAST_URL = 'REMOVE_LAST_URL';
export const TOGGLE_FILTER_OPTION = 'TOGGLE_FILTER_OPTION';
export const CLEAR_FILTER_OPTIONS = 'CLEAR_FILTER_OPTIONS';
export const SET_PAGE_CONFIG_STATE = 'SET_PAGE_CONFIG_STATE';
export const SET_PAGE_NUMBER = 'SET_PAGE_NUMBER';
export const SET_ACTIVE_BROWSE_SUBTAB = 'SET_ACTIVE_BROWSE_SUBTAB';
export const REMOVE_CUSTOM_CONTENT = 'REMOVE_CUSTOM_CONTENT';
export const TOGGLE_FILTER_GROUP = 'TOGGLE_FILTER_GROUP';
export const CLEAR_FILTER_GROUPS = 'CLEAR_FILTER_GROUPS';
